import script from "./LifecycleHooksMain.vue?vue&type=script&setup=true&lang=ts"
export * from "./LifecycleHooksMain.vue?vue&type=script&setup=true&lang=ts"

import "./LifecycleHooksMain.vue?vue&type=style&index=0&id=47144ef6&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47144ef6"]])

export default __exports__